import {
  SearchFieldKeys,
  SoftwareLicenceSummaryKeys,
  TableColumn,
  licenceTypeOption,
  paymentTypeOption,
} from "@sso/types";

export const licenceTypeTableColumns: TableColumn<string>[] = [
  {
    name: "Name",
    field: SoftwareLicenceSummaryKeys.NAME,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Type",
    field: SoftwareLicenceSummaryKeys.LICENCE_TYPE,
    sortable: true,
    search: { type: SearchFieldKeys.SELECT, options: licenceTypeOption },
  },
  {
    name: "Payment",
    field: SoftwareLicenceSummaryKeys.PAYMENT_TYPE,
    sortable: true,
    search: { type: SearchFieldKeys.SELECT, options: paymentTypeOption },
  },
  {
    name: "Expires after",
    field: SoftwareLicenceSummaryKeys.EXPIRY_STRING,
    sortable: true,
  },
  {
    name: "Number of licenced users",
    field: SoftwareLicenceSummaryKeys.NUMBER_OF_LICENCED_USERS,
    sortable: true,
  },
];
